import React from 'react';
import { PositionSide } from 'wintrado-api';

export const BuySellIcon = ({ side, width = 10, height = 10 }) => {
	if (side === PositionSide.BUY) {
		return <img style={{ width, height, marginRight: 2 }} src={require('../images/buy_small.png')} />;
	}
	return <img style={{ width, height, marginRight: 2 }} src={require('../images/sell_small.png')} />;
};
